export class Subscribable<T> {
  protected readonly _listeners: Set<T> = new Set();

  subscribe(listener: T): () => void {
    this._listeners.add(listener);
    return () => this._listeners.delete(listener);
  }
}
